/**
 * Brands Block JavaScript
 * Scroll-triggered GSAP animations
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initBrands() {
        const blocks = document.querySelectorAll('.brands');
        
        blocks.forEach(block => {
            // Initialize animations
            initScrollAnimations(block);
            
            console.log('[BLOCK] brands block initialized');
        });
    }

    /**
     * Initialize scroll-triggered GSAP animations
     */
    function initScrollAnimations(block) {
        // Function to run animations
        function runAnimations() {
            // Get animation elements
            const animatedElements = block.querySelectorAll('[data-gsap-animate]');
            
            if (animatedElements.length === 0) return;

            // Set initial states
            gsap.set(animatedElements, { opacity: 0, y: 30 });

            // Create GSAP timeline
            const tl = gsap.timeline({
                defaults: { ease: 'power2.out' }
            });

            // Animate each element with its individual delay
            animatedElements.forEach(element => {
                const delay = parseFloat(element.getAttribute('data-gsap-delay')) || 0;
                
                tl.to(element, {
                    opacity: 1,
                    y: 0,
                    duration: 0.8,
                }, delay / 1000); // Convert milliseconds to seconds
            });

            console.log('[BLOCK] Brands animations triggered');
        }

        // Use Intersection Observer to trigger animations when block enters viewport
        function setupScrollTrigger() {
            const observerOptions = {
                root: null,
                rootMargin: '0px',
                threshold: 0.15 // Trigger when 15% of block is visible
            };

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // Block is in viewport, run animations
                        runAnimations();
                        // Disconnect observer after first trigger
                        observer.disconnect();
                    }
                });
            }, observerOptions);

            observer.observe(block);
        }

        // Wait for GSAP to be available, then setup scroll trigger
        if (typeof gsap !== 'undefined') {
            setupScrollTrigger();
        } else {
            // Poll for GSAP with timeout
            let attempts = 0;
            const maxAttempts = 50; // 5 seconds max
            const checkGSAP = setInterval(() => {
                attempts++;
                if (typeof gsap !== 'undefined') {
                    clearInterval(checkGSAP);
                    setupScrollTrigger();
                } else if (attempts >= maxAttempts) {
                    clearInterval(checkGSAP);
                    console.log('[BLOCK] GSAP not available after timeout, skipping animations');
                }
            }, 100);
        }
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initBrands);
    } else {
        initBrands();
    }
})();
